import { RequestParameterTypeEnum } from "../Enums/RequestParameterTypeEnum";

function headingForIdentificatorType(type: RequestParameterTypeEnum): string | null {
    switch (type) {
        case RequestParameterTypeEnum.PARTNER_ID:
            return "Klient pre vykonanie zmeny";
        case RequestParameterTypeEnum.POISTKA_ID:
            return "Zmluva pre vykonanie zmeny";
        case RequestParameterTypeEnum.SKODA_ID:
            return "Škoda pre vykonanie zmeny";
        default:
            return null;
    }
}

export function getIdentificatorHeadingForField(fieldType: RequestParameterTypeEnum): string | null {
    return headingForIdentificatorType(fieldType);
}

/** Heading for the section banner: same copy as the field wrapper, keyed by the first identificator in section order (PZ/SK/PA are not mixed on one request). */
export function getIdentificatorHeadingForSection(
    identificatorType: RequestParameterTypeEnum | null
): string | null {
    return identificatorType == null ? null : headingForIdentificatorType(identificatorType);
}
